<template>
  <div class="app-input-textarea">
    <div v-if="optionPrefix">{{optionPrefix}}</div>
    <el-input type="textarea"
      ref="input"
      v-model="model"
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled="computedDisabled"
      :class="optionClass"
      :autosize="autosize"
      @keydown.enter.native="onEnterKey($event)"
      @focus="onFocus"
      @blur="onBlur"
      @change="onChange"
      @clear="onClear"></el-input>
    <div class="app-input-textarea-hint" :class="{'is-disabled': computedDisabled}"><i class="el-icon-info"></i> Shift+Enterで改行を入力できます</div>
    <div v-if="optionSuffix">{{optionSuffix}}</div>
  </div>
</template>

<style>
.app-input-textarea-hint {
  font-size:8px;
}
.app-input-textarea-hint.is-disabled {
  color: rgb(220, 223, 230);
}
</style>

<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppInputComponent from './AppInputComponent';

@Component
export default class AppInputTextarea extends AppInputComponent {
  /**
   * autosize
   */
  get autosize () {
    return (this.options && 'autosize' in this.options) ? this.options.autosize : { minRows: 2, maxRows: 6 };
  }

  // エンターキーイベント
  onEnterKey (event) {
    // Shiftキーと同時に押下された場合はフォーカス遷移しない
    if (event.shiftKey) {
      return;
    }
    this.$emit('app-event', 'enterkey', event, this);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/input/AppInputTextarea.vue